import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { Alert, Modal, ModalBody, ModalFooter } from "reactstrap";
import { Heading2, MarbleButton } from "..";
import "./portal-modal.scss";

export const PortalModal: React.FC<{
  title: string;
  buttonsSection: Array<
    React.ReactElement<React.ComponentProps<typeof MarbleButton>>
  >;
  showCloseIcon?: boolean;
  alert?: React.ReactElement<React.ComponentProps<typeof Alert>>;
  onClose: () => void;
  onGoBack?: () => void;
}> = ({
  title,
  buttonsSection,
  showCloseIcon = false,
  alert,
  onClose,
  onGoBack,
  children,
}) => {
  return (
    <>
      <Modal isOpen centered className="text-center">
        <div className="d-flex pb-0 pt-4 ps-4 pe-4 me-2">
          {onGoBack && (
            <div>
              <HiArrowNarrowLeft
                onClick={() => onGoBack()}
                size={24}
                className="modal-header-icon"
              />
            </div>
          )}
          {alert && <div>{alert}</div>}
          {showCloseIcon && (
            <div className="ms-auto">
              <AiOutlineClose
                onClick={onClose}
                size={24}
                className="modal-header-icon"
              />
            </div>
          )}
        </div>
        <ModalBody className="modal-body pt-1 ps-4 pe-4">
          <Heading2 text={title} />
          {children}
        </ModalBody>
        <ModalFooter className="modal-footer flex-column ps-4 pe-4">
          {buttonsSection.map((m, idx) => (
            <div
              key={idx}
              className={`${m.props.type !== "link" ? "w-100" : ""}`}
            >
              {m}
            </div>
          ))}
        </ModalFooter>
      </Modal>
    </>
  );
};
